/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {TopNavNotificationIcon} from '../icons/TopNavNotificationIcon';
import {toggleThemeStyle} from '../theme/helpers';
import {dlsColor} from '../theme/theme';
import useThemeContext from '../theme/useThemeContext';
import {DLSTheme, IconSize} from '../types/types';

export interface EmptyNotificationsType {
  title: string;
  desktopHeight?: string;
  mobileHeight?: string;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  emptyNotifications : {
    height                         : ({desktopHeight}: {desktopHeight: string}) => desktopHeight,
    display                        : 'flex',
    justifyContent                 : 'center',
    alignItems                     : 'center',
    flexDirection                  : 'column',
    [theme.breakpoints.down('sm')] : {
      height : ({mobileHeight}: {mobileHeight: string}) => mobileHeight
    }
  },
  emptyNotificationsIcon : {
    margin         : toggleThemeStyle('-70px 0 24px', '10px 0 4px'),
    display        : 'flex',
    justifyContent : 'center'
  },
  emptyNotificationCard : {
    width           : '424px',
    height          : '148px',
    borderRadius    : '12px',
    backgroundColor : dlsColor('grey13')
  },
  emptyNotificationsText : toggleThemeStyle({
    fontFamily : 'Roboto',
    fontWeight : 500,
    fontSize   : '24px',
    lineHeight : '28px',
    color      : dlsColor('grey2')
  }, {
    color          : dlsColor('grey2'),
    display        : 'flex',
    fontSize       : '20px',
    fontFamily     : 'Inter',
    fontWeight     : 600,
    lineHeight     : '22px',
    letterSpacing  : '0px',
    justifyContent : 'center'
  })
}) as any);

export const EmptyNotifications = ({
  title,
  desktopHeight = '100%',
  mobileHeight = '100%'
}: EmptyNotificationsType) => {
  const classes = useStyles({desktopHeight, mobileHeight});

  const {
    isCurrent : isCurrentTheme
  } = useThemeContext();

  return (
    <div className={classes.emptyNotifications}>
      <div className={isCurrentTheme ? classes.emptyNotificationCard : ''}>
        <div className={classes.emptyNotificationsIcon}>
          <TopNavNotificationIcon size={IconSize.large} />
        </div>
        <div className={classes.emptyNotificationsText}>{title}</div>
      </div>
    </div>
  );
};

export default EmptyNotifications;
